import { createApp } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import vuetify from './plugins/vuetify';
import App from './App.vue';

library.add(fas);

const app = createApp(App)
app.use(vuetify)
app.component('fa' , FontAwesomeIcon);
app.mount('#app')
